import type { Customer } from '@/services/customers/types'

/** Stable business code for the suggested default on product create. */
export const DEFAULT_CREATE_CUSTOMER_CODE = 'TJX'

/** Exact display name used in production for TJX (paired with code TJX). */
export const DEFAULT_CREATE_CUSTOMER_NAME =
  'The TJX Companies, Inc. Home Page'

/**
 * Pick the default “Khách hàng” suggestion for ProductCreatePage.
 * Prefer code `TJX`, then exact name — never hardcode customer id.
 */
export function pickDefaultCreateCustomer(
  customers: Customer[],
): Customer | null {
  const active = customers.filter((c) => c.status === 'active')
  const byCode = active.find(
    (c) => c.code.trim().toUpperCase() === DEFAULT_CREATE_CUSTOMER_CODE,
  )
  if (byCode) return byCode

  const byName = active.find(
    (c) => c.name.trim() === DEFAULT_CREATE_CUSTOMER_NAME,
  )
  if (byName) return byName

  return null
}
